// frontend/src/pages/dashboard/ProjectComponents/ProjectCardSkeleton.js
import React from 'react';
import { Card, CardHeader, CardContent, CardActions, Box, Grid, Skeleton } from '@mui/material';

const ProjectCardSkeleton = () => (
  <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, overflow: "hidden" }}>
    <CardHeader
      title={<Skeleton variant="text" width="60%" height={40} />}
      subheader={<Skeleton variant="text" width="80%" height={20} />}
      action={<Skeleton variant="circular" width={32} height={32} />}
      sx={{ pb: 0 }}
    />
    <CardContent>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item size={{ xs: 6 }} key={item}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Skeleton variant="circular" width={20} height={20} />
              <Skeleton variant="text" width="80%" height={20} />
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Skeleton variant="circular" width={20} height={20} />
        <Skeleton variant="text" width="60%" height={20} />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Skeleton variant="circular" width={20} height={20} />
        <Skeleton variant="text" width="40%" height={20} />
      </Box>
    </CardContent>
    <CardActions sx={{ justifyContent: "space-between", px: 2, pb: 2 }}>
      <Box sx={{ display: "flex", gap: 1 }}>
        {[1, 2, 3, 4, 5].map((item) => (
          <Skeleton key={item} variant="circular" width={32} height={32} />
        ))}
      </Box>
      <Skeleton variant="rectangular" width={40} height={24} />
    </CardActions>
  </Card>
);

export default ProjectCardSkeleton;